import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
//import Paper from "@mui/material/Paper";
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import DialogContent from '@mui/material/DialogContent';
import Selector from '../select';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import '../../index.css';
import { DialogActions } from '@mui/material';
import Button from '@mui/material/Button';
import { toast } from 'react-toastify';
import Divider from '@mui/material/Divider';
import spinner from '../assign-prescriptions/images/spinner.gif';
import { withTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';
import { Help } from '@mui/icons-material';

const styles = (theme) => ({
  root: {
    width: '100%',
    height: '80vh',
  },
  flexItems: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  twoChildren: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftChild: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: '45%',
    margin: '1%',
  },
  rightChild: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    margin: '1%',
  },
  footer: {
    margin: '8px 4px',
    bottom: '0',
    right: '0',
    textAlign: 'center',
    position: 'fixed',
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
  btnremove: {
    padding: '8px 2px',
    fontSize: '0.675rem',
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none',
  },
  hidden: {
    display: 'none',
  },
  catLable: {
    color: '#000',
    fontSize: '0.8rem',
    marginLeft: '-2.5%',
    marginTop: '1.5%',
    width: '95%',
  },
  subCatGrid: {
    marginTop: '-1%',
    marginLeft: '3%',
  },
  subCatLable: {
    color: '#000',
    fontSize: '0.8rem',
    marginLeft: '-10%',
  },
  '@media only screen and (min-width: 992px)': {
    catLable: {
      color: '#000',
      fontSize: '0.8rem',
      marginLeft: '-20px',
      marginTop: '17px',
      width: '90%',
    },
    subCatGrid: {
      marginTop: '-10px',
      marginLeft: '30px',
    },
    subCatLable: {
      color: '#000',
      fontSize: '0.8rem',
      marginLeft: '-20px',
    },
  },
  ' @media only screen and (min-width: 1200px)': {
    catLable: {
      color: '#000',
      fontSize: '0.8rem',
      marginLeft: '-1.5%',
      marginTop: '1%',
      width: '95%',
    },
    subCatGrid: {
      marginTop: '-1%',
      marginLeft: '3%',
    },
    subCatLable: {
      color: '#000',
      fontSize: '0.8rem',
      marginLeft: '-10%',
    },
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8',
    },
  },
});

class Rolepermissions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      account_id: null,
      isaccountid: null,
      role_id: null,
      selected: [],
      permissiondata: [],
      categorydata: [],
      uniquePermissionCategories: [],
      subCategories: [],
      // checkedPermission:[],
      CheckedPermissionParentCategory: [],
      CheckedPermissionSubCategory: [],
      //setrolepermission:[],
      viewcheckedPermissionSubCategory: [],
      isCheckedpermissiom: false,
      loader: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'accounts', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        if (data) {
          // data.map(n => {
          //   n.parent = n.parent ? n.parent.name: '' ;
          //   n.type   = n.type ? n.type.name : '';
          //   return  n;
          // });
          this.setState({ data });
          this.setState({ loader: false });
        }
      });
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'roles', {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((roles) => {
        const roleValues = roles.map((role) => {
          return { value: role.id, label: this.props.t(role.name_es) };
        });
        this.setState({ roleValues, role_id: roleValues[0].value });
      });
    fetch(process.env.REACT_APP_BASEURL + 'accounts', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((accounts) => {
        const accountValues = accounts.map((account) => {
          return { value: account.id, label: account.name };
        });
        this.setState({ accountValues, account_id: accountValues[0].value });
        this.setState({ loader: false });
      });
  }

  Getpermissions(roleid) {
    this.setState({ loader: true });
    const permission = {
      accountid: this.state.account_id,
      roleid: roleid,
    };
    fetch(process.env.REACT_APP_BASEURL + 'permissions', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(permission),
    })
      .then((response) => response.json())
      .then((permissiondata) => {
        this.setState({ loader: false });
        if (permissiondata) {
          this.setState({ permissiondata });
          this.getParentCategories();
        }
      });
  }

  setpermissions() {
    //  let viewcheckedPermissionSubCategory = [];
    if (this.state.permissiondata && this.state.permissiondata.length > 0) {
      for (let i = 0; i < this.state.permissiondata.length; i++) {
        //role_id = selectedObject.permission_datail[i].role_id;
        let viewcheckedPermissionSubCategory = this.state.CheckedPermissionSubCategory.map(
          (item) => {
            if (item.value === this.state.permissiondata[i].permission_id) {
              item['status'] = this.state.permissiondata[i].is_allowed;
            }
            return item;
          }
        );
        this.setState(viewcheckedPermissionSubCategory);
      }
    }
  }
  checkValueOfCategory(id) {
    let result = false;
    let obj = this.state.CheckedPermissionParentCategory.find(
      (obj) => obj.value === id
    );
    if (obj !== undefined) {
      result = obj['status'];
    }
    return result;
  }
  checkValueOfsubCategory(id) {
    let result = false;
    let obj = this.state.CheckedPermissionSubCategory.find(
      (obj) => obj.value === id
    );
    if (obj !== undefined) {
      result = obj['status'];
    }
    return result;
  }
  parentcheckpermission = (id) => {
    // let obj = this.state.CheckedPermissionParentCategory.find(obj =>  obj.value === id);
    this.state.CheckedPermissionParentCategory.map((item) => {
      if (item.value === id) {
        item.status = !item.status;
      }

      return item;
    });

    let obj1 = this.state.CheckedPermissionParentCategory.find(
      (obj) => obj.value === id
    );

    this.state.CheckedPermissionSubCategory.map((item) => {
      if (item.parentvalue === id) {
        if (obj1.status) {
          item.status = true;
        } else {
          item.status = false;
        }
      }

      return item;
    });
    this.forceUpdate();
  };

  //sub
  checkedPermission = (elem_id) => {
    //let obj = this.state.CheckedPermissionSubCategory.find(obj =>  obj.value === elem_id);
    this.state.CheckedPermissionSubCategory.map((item) => {
      if (item.value === elem_id) {
        item.status = !item.status;
      }

      return item;
    });

    let obj1 = this.state.CheckedPermissionSubCategory.find(
      (obj) => obj.value === elem_id
    );
    this.state.CheckedPermissionParentCategory.map((item) => {
      if (item.value === obj1.parentvalue && obj1.status === false) {
        item.status = false;
      }
      return item;
    });
    let obj2 = this.state.CheckedPermissionSubCategory.filter(
      (obj2) => obj2.parentvalue === obj1.parentvalue
    );
    if (obj2 !== undefined) {
      obj2.forEach((item) => {
        if (item.status === false) {
          this.state.CheckedPermissionParentCategory.map((parentitem) => {
            if (parentitem.value === item.parentvalue) {
              parentitem.status = false;
            }
            return parentitem;
          });
        } else {
          let obj3 = obj2.filter((obj2) => obj2.status === true);
          if (obj3.length === obj2.length) {
            this.state.CheckedPermissionParentCategory.map((parentitem) => {
              if (parentitem.value === item.parentvalue) {
                parentitem.status = true;
              }
              return parentitem;
            });
          }
        }
      });
    }

    this.forceUpdate();
  };
  getParentCategories = () => {
    const uniqueCategories = this.getUnique(
      this.state.permissiondata,
      'entity_type_id'
    );
    this.setState({ uniquePermissionCategories: uniqueCategories });
    const paraentaarray = this.state.uniquePermissionCategories.map((item) => {
      return {
        value: item.entity_type_id,
        label: item.entity_name,
        status: item.status,
      };
    });
    this.setState({ CheckedPermissionParentCategory: paraentaarray });
    const subaaray = this.state.permissiondata.map((item) => {
      return {
        parentvalue: item.entity_type_id,
        parenetlabel: item.entity_name,
        value: item.id,
        label: item.name,
        status: item.status,
      };
    });
    this.setState({ CheckedPermissionSubCategory: subaaray });
  };

  getUnique = (arr, comp) => {
    const unique = arr
      .map((e) => e[comp])
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter((e) => arr[e])
      .map((e) => arr[e]);
    return unique;
  };
  handleChange = (event) => {
    //event.preventDefault && event.preventDefault();

    const user = {};
    user[event.target.id || event.target.name] = event.target.value;
    this.setState(user);
    this.setState({ isaccountid: event.target.value });
  };
  handleChangeRole = (event) => {
    //event.preventDefault && event.preventDefault();

    // let role = {};
    // role[event.target.id || event.target.name] = event.target.value;
    this.setState({ role_id: event.target.value });

    this.Getpermissions(event.target.value);
    this.setpermissions();
  };
  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ loader: true });
    const roles = {
      account_id: this.state.account_id,
      role_id: this.state.role_id,
      permissions: this.state.CheckedPermissionSubCategory,
    };
    // var data = new FormData();
    // data.append("account_id", this.state.account_id);
    // data.append("role_id",this.state.role_id);
    //data.append("permissions",JSON.stringify(this.state.CheckedPermissionSubCategory));
    const result = fetch(process.env.REACT_APP_BASEURL + 'rolepermissions', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(roles),
    });
    result
      .then((result) => {
        result.json().then((res) => {
          this.setState({ loader: false });
          if (res.error) {
            //this.setState({isButtonDisabled: false,submitted: false});
            this.setState({ errorMessage: res.error.message });
          } else {
            this.state.data.unshift(res.account);
            const newData = JSON.parse(JSON.stringify(this.state.data));
            this.setState({ errorMessage: '', data: newData });
            toast.success(this.props.t('Role.Permission.Success'));
          }
        });
      })
      .catch((error) => {
        this.setState({ loader: false });
        this.setState({ errorMessage: error.message });
      });
  };

  getFLPTooltipById = (t, elemId) => {
    const FrontDoorTitle = t('API.Roles.Permission.FrontDoor.Title');
    const RightDoorTitle = t('API.Roles.Permission.RightDoor.Title');
    const LeftDoorTitle = t('API.Roles.Permission.LeftDoor.Title');
    let title = '';
    if(elemId === 'b3e8fba2-7170-4214-a6e9-6e2f3932f197') { // Front Door Access Tooltip
      title = FrontDoorTitle;
    } else if(elemId === '335cc9af-5c5d-4269-9e0e-e84133f191b0') { // Right Door Access Tooltip
      title = RightDoorTitle;
    } else if(elemId === '0f8fc54a-833a-47fc-be21-3725e3c28898') { // Left Door Access Tooltip
      title = LeftDoorTitle;
    }
    return title;
  }


  render() {
    const { classes, t } = this.props;
    const { permissiondata } = this.state;
    let isButtonDisabled = false;
    if (this.state.isaccountid !== null) {
      isButtonDisabled = false;
    } else {
      isButtonDisabled = true;
    }
    
    return (
      <div className={classes.root}>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt='loading' />
          </div>
        ) : null}
        <div>
          <div className={classes.twoChildren}>
            <div className={classes.leftChild}>
              <Selector
                name='accounts'
                id='account_id'
                label={t('Role.SelectAccount')}
                style={{ width: '50%' }}
                values={this.state.accountValues}
                onBlur={this.handleChange}
              />
            </div>
            <div className={classes.rightChild}>
              <Selector
                name='roles'
                id='role_id'
                label={t('Role.SelectRole')}
                style={{ width: '50%' }}
                values={this.state.roleValues}
                selected={this.state.role_id}
                onBlur={this.handleChangeRole}
                lookup={this.state.roleLookupValues}
              />
            </div>
          </div>
        </div>
        <Divider sx={{ marginTop: '10px', height: '10px' }} />
        {permissiondata.length > 0 ? (
          <React.Fragment>
            <DialogContent>
              <div>
                <Typography
                  variant='title'
                  gutterBottom
                  style={{
                    marginBottom: '0.35em',
                    color: 'rgba(0, 0, 0, 0.87)',
                    fontSize: '1.3125rem',
                    fontWeight: 500,
                    lineHeight: '1.16667em',
                  }}
                >
                  {t('Role.PermissionText')}
                </Typography>
                <Grid container>
                  {this.state.uniquePermissionCategories.map((items) => {
                    return (
                      <React.Fragment>
                        <Grid container item xs={12} direction='row'>
                          <FormControlLabel
                            key={items.entity_name}
                            control={
                              <Checkbox
                                checked={this.checkValueOfCategory(
                                  items.entity_type_id
                                )}
                                onChange={() =>
                                  this.parentcheckpermission(
                                    items.entity_type_id
                                  )
                                }
                                value={items.entity_name}
                                sx={{ '&.Mui-checked': { color: '#0ae' } }}
                              />
                            }
                            label={
                              <span style={{ fontSize: '0.8rem' }}>
                                {t(items.entity_name_lang_key)}
                              </span>
                            }
                          />
                        </Grid>
                        {permissiondata
                          .filter(
                            (item) =>
                              item.entity_type_id === items.entity_type_id
                          )
                          .map((elem, inx) => {
                            return (
                              <Grid
                                key={inx}
                                item
                                xs={
                                  items.entity_name === 'Delivery Tech' ? 4 : 2
                                }
                                style={{ display: 'flex', alignItems: 'center' }}
                                sx={{ ml: '3%' }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={this.checkValueOfsubCategory(
                                        elem.id
                                      )}
                                      onChange={() =>
                                        this.checkedPermission(elem.id)
                                      }
                                      value={elem.name}
                                      sx={{
                                        '&.Mui-checked': { color: '#0ae' },
                                      }}
                                    />
                                  }
                                  label={
                                    <span style={{ fontSize: '0.8rem' }}>
                                      {t(elem.name_lang_key)}
                                    </span>
                                  }
                                />&nbsp;{
                                  (
                                    elem.id === 'b3e8fba2-7170-4214-a6e9-6e2f3932f197' ||
                                    elem.id === '335cc9af-5c5d-4269-9e0e-e84133f191b0' ||
                                    elem.id === '0f8fc54a-833a-47fc-be21-3725e3c28898') ?
                                    (
                                      <Tooltip
                                        title={this.getFLPTooltipById(t, elem.id)}
                                        className={classes.customWidth}
                                      >
                                        <Help
                                          className={classes.helpIcon}
                                        ></Help>
                                      </Tooltip>
                                    ) : ''
                                }
                              </Grid>
                            );
                          })}
                      </React.Fragment>
                    );
                  })}
                </Grid>
              </div>
            </DialogContent>
            <DialogActions sx={{ padding: '10px' }}>
              <Button
                type='button'
                color='primary'
                variant='contained'
                className={classes.primaryButton}
                style={{ width: '8%' }}
                onClick={this.handleSubmit}
                disabled={isButtonDisabled}
              >
                {t('Role.SaveButton')}
              </Button>
            </DialogActions>
          </React.Fragment>
        ) : (
          ''
        )}
      </div>
    );
  }
}

Rolepermissions.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(
  withTranslation()(Rolepermissions)
);



// WEBPACK FOOTER //
// ./src/components/user-role/index.js